<template>
    <article class="Formation Formation--memberarea" v-if="formation">
        <div class="row">
            <div class="col-md-8">
                <div class="Formation__left">
                    <button type="button" @click="goBack" class="Formation__list">
                        <i class="fa fa-list"></i>
                        Retour
                    </button>
                    <div v-if="formation.requirements.length > 0">
                        <header class="Formation__header">
                            <h1 class="Formation__title">Avant la formation</h1>
                        </header>
                        <section class="Formation__section">
                            <div class="Formation__section-content">
                                <ul>
                                    <formation-dependencies-list :formations="formation.requirements"/>
                                </ul>
                            </div>
                        </section>
                        <div class="text-center m-t-30 m-b-30">
                            <svg height="100" viewBox="0 0 38 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="19.5" cy="36.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="60.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="84.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="108.5" r="4.5" fill="#cccccc"/>
                                <path
                                    d="M38 18.8556L19 0L-1.24239e-06 18.8556L3.16629 22L19 6.28444L34.8337 22L38 18.8556Z"
                                    fill="#cccccc"/>
                                <path
                                    d="M38 126.144L19 145L-1.24239e-06 126.144L3.16629 123L19 138.716L34.8337 123L38 126.144Z"
                                    fill="#cccccc"/>
                            </svg>
                        </div>
                    </div>

                    <header class="Formation__header">
                        <h1 class="Formation__title">{{ formation.name }}</h1>
                    </header>
                    <section class="Formation__section">
                        <div v-if="formation.excerpt">
                            <h2 class="Formation__section-title">Présentation succinte du métier</h2>
                            <div class="Formation__section-content" v-html="formation.excerpt"></div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <a :href="formation.pdf_file" v-if="formation.pdf_file" target="_blank"
                                   class="Btn Btn--stroked Btn--block Btn--primary m-t-15">
                                    Fiche formation
                                </a>
                            </div>
                            <div class="col-md-6">
                                <button
                                    @click="open"
                                    type="button"
                                    class="Btn Btn--block Btn--primary m-t-15">Je m'inscris
                                </button>
                            </div>
                        </div>
                    </section>
                    <section class="Formation__section" v-if="metas.jobs">
                        <h2 class="Formation__section-title">Métier(s) auxquels conduit la
                            formation</h2>
                        <div class="Formation__section-content" v-html="metas.jobs"></div>
                    </section>
                    <section class="Formation__section" v-if="metas.goals">
                        <h2 class="Formation__section-title">
                            Objectifs généraux de la formation
                        </h2>
                        <div class="Formation__section-content" v-html="metas.goals"></div>
                    </section>
                    <section class="Formation__section"
                             v-if="metas.skills || metas.safety_knowledge || metas.knowledge">
                        <h2 class="Formation__section-title">
                            Programme de la formation
                        </h2>
                        <div class="Formation__section-content">
                            <p>Combinaison de connaissances et d’acquisition de compétences
                                professionnelles, de connaissances en matière de santé et sécurité
                                professionnelles et de connaissances générales associées aux
                                connaissances professionnelles</p>
                            <br>
                            <div v-if="metas.skills">
                                <h3 class="Formation__section-subtitle">Connaissances et acquisition
                                    de compétences professionnelles
                                    dans les domaines de :</h3>
                                <div v-html="metas.skills"></div>
                            </div>
                            <div v-if="metas.safety_knowledge">
                                <h3 class="Formation__section-subtitle">Connaissances en matière de
                                    santé et sécurité
                                    professionnelles :</h3>
                                <div v-html="metas.safety_knowledge"></div>
                            </div>
                            <div v-if="metas.knowledge">
                                <h3 class="Formation__section-subtitle">Connaissances générales
                                    associées aux connaissances
                                    professionnelles :</h3>
                                <div v-html="metas.knowledge"></div>
                            </div>
                        </div>
                    </section>
                    <section class="Formation__section"
                             v-if="metas.teaching_methods || metas.technical_tools || metas.human_resources || metas.assessment_methods">
                        <h2 class="Formation__section-title">
                            Modalités pédagogiques
                        </h2>
                        <div class="Formation__section-content">
                            <div v-if="metas.teaching_methods">
                                <h3 class="Formation__section-subtitle">Méthodes pédagogiques:</h3>
                                <div v-html="metas.teaching_methods"></div>
                            </div>
                            <div v-if="metas.technical_tools">
                                <h3 class="Formation__section-subtitle">Outils et moyens techniques:</h3>
                                <div v-html="metas.technical_tools"></div>
                            </div>
                            <div v-if="metas.human_resources">
                                <h3 class="Formation__section-subtitle">Moyens humains:</h3>
                                <div v-html="metas.human_resources"></div>
                            </div>
                            <div v-if="metas.assessment_methods">
                                <h3 class="Formation__section-subtitle">Modalité d'évaluation:</h3>
                                <div v-html="metas.assessment_methods"></div>
                            </div>
                        </div>
                    </section>

                    <div v-if="formation.openings.length > 0 || formation.deliver_job">
                        <div class="text-center m-t-30 m-b-30">
                            <svg height="100" viewBox="0 0 38 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="19.5" cy="36.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="60.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="84.5" r="4.5" fill="#cccccc"/>
                                <circle cx="19.5" cy="108.5" r="4.5" fill="#cccccc"/>
                                <path
                                    d="M38 18.8556L19 0L-1.24239e-06 18.8556L3.16629 22L19 6.28444L34.8337 22L38 18.8556Z"
                                    fill="#cccccc"/>
                                <path
                                    d="M38 126.144L19 145L-1.24239e-06 126.144L3.16629 123L19 138.716L34.8337 123L38 126.144Z"
                                    fill="#cccccc"/>
                            </svg>
                        </div>
                        <header class="Formation__header">
                            <h1 class="Formation__title">Après la formation</h1>
                        </header>
                        <section class="Formation__section">
                            <div class="Formation__section-content">
                                <ul>
                                    <li v-if="formation.deliver_job">
                                        Emploi
                                    </li>
                                    <formation-dependencies-list :formations="formation.openings"/>
                                </ul>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <section class="Formation__sidebar">
                    <h2 class="Formation__sidebar-title">
                        <i class="fas fa-info-circle m-r-5"></i> Informations
                    </h2>
                    <div v-if="formation.rncp" class="Formation__sidebar-item">
                        <b class="uppercase">Code RNCP:</b>
                        <span>{{ formation.rncp }}</span>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.public">
                        <b class="m-b-5 d-block uppercase">Public concerné</b>
                        <p v-html="metas.public"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.access_conditions">
                        <b class="m-b-5 d-block uppercase">Conditions d'accès</b>
                        <p v-html="metas.access_conditions"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.duration">
                        <b class="m-b-5 d-block uppercase">Durée</b>
                        <p v-html="metas.duration"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="formation.campuses.length > 0">
                        <b class="m-b-5 d-block uppercase">Site(s) de formation</b>
                        <ul>
                            <li v-for="campus in formation.campuses">{{ campus.name }}</li>
                        </ul>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.organization">
                        <b class="m-b-5 d-block uppercase">Organisation de la formation</b>
                        <p v-html="metas.organization"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.groups">
                        <b class="m-b-5 d-block uppercase">Effectif</b>
                        <p v-html="metas.groups"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.period">
                        <b class="m-b-5 d-block uppercase">Période d'entrée en formation</b>
                        <p v-html="metas.period"></p>
                    </div>
                    <div class="Formation__sidebar-item" v-if="metas.cost">
                        <b class="m-b-5 d-block uppercase">Coût de la formation</b>
                        <p v-html="metas.cost"></p>
                    </div>
                </section>
            </div>
        </div>
    </article>
</template>

<script>
import FormationIcon from "../icons/FormationIcon";
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import {actions, getters} from "../../store";
import ModalBus from '../../eventBus';
import FormationRegistrationModal from '../Modals/Contact/FormationRegistrationModal'
import FormationDependenciesList from "./FormationDependenciesList";

export default {
    components: {FormationDependenciesList, FormationIcon, Multiselect},
    watch: {
        folder: function () {
            actions.fetchSuggestions(this.folder.id);
        }
    },
    computed: {
        folder: function () {
            if (!this.$route.params.folderId) {
                let folders = getters.folders();
                if (folders.length <= 0) {
                    return null;
                }

                return folders[0];
            }

            return getters.folders().find(folder => folder.id === this.$route.params.folderId);
        },
        formation: function () {
            return getters.suggestion(this.$route.params.formationId);
        },
        metas: function () {
            return this.formation.metas;
        }
    },
    methods: {
        open: function () {
            let {id, rncp, ref, name, campuses, register_link} = this.formation;
            if (register_link){
                window.open(register_link);
                return;
            }

            this.$root.openFormation({
                id,
                rncp,
                name,
                ref,
                campuses: campuses.map(campus => ({id: campus.id, name: campus.name}))
            });
        },
        goBack: function () {
            if (this.$user.type === this.$enums.UserType.COMPANY) {
                return this.$router.push({name: 'folders_view', params: {folderId: this.$route.params.folderId}})
            }

            return this.$router.push({name: 'formations'})
        }
    }
}
</script>
